export enum CostListItemMode {
  All = "all",
  Any = "any",
  Group = "group",
}
